<ng-container *transloco="let t">
  <div
    id="push-notification-modal-backdrop"
    class="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
    role="dialog"
    aria-modal="true"
    (click)="onBackdropClick($event)"
    (keydown.escape)="onSkip()"
    tabindex="-1"
  >
    <div
      id="push-notification-modal-content"
      class="bg-white rounded-[24px] shadow-xl max-w-md w-full mx-4 overflow-hidden"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="'push-notification-modal-title'"
    >
      <div id="push-notification-modal-header" class="px-6 pt-8 pb-4 text-center">
        <div class="mx-auto w-24 h-24 mb-6 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="w-20 h-20 text-ld-primary"
          >
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
            <circle cx="18" cy="4" r="3" fill="currentColor" class="text-red-500" />
          </svg>
        </div>

        <h2 id="push-notification-modal-title" class="text-2xl font-semibold text-ld-neutral-700 mb-2">
          {{ t('pushNotificationModalTitle') }}
        </h2>
      </div>

      <div id="push-notification-modal-body" class="px-6 pb-6 text-center">
        <p id="push-notification-modal-message" class="text-ld-neutral-600 leading-relaxed">
          {{ t('pushNotificationModalMessage') }}
        </p>
      </div>

      <div id="push-notification-modal-footer" class="px-6 pb-8 flex flex-col gap-3">
        <button
          id="push-notification-modal-allow-button"
          type="button"
          class="btn-primary-ld-purple !order-0 !w-full"
          [disabled]="isLoading()"
          (click)="onAllow()"
        >
          @if (isLoading()) {
            <mat-spinner diameter="16" class="!w-4 !h-4 [&_circle]:!stroke-white"></mat-spinner>
          }
          {{ t('pushNotificationModalAllow') }}
        </button>

        <button
          id="push-notification-modal-skip-button"
          type="button"
          class="btn-outline-ld-purple !order-1 !w-full"
          [disabled]="isLoading()"
          (click)="onSkip()"
        >
          {{ t('pushNotificationModalDontAllow') }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
